// helpDeskService.js - API Service Layer for Help Desk Module

import axiosInstance from '../../../utils/axiosInstance';

// ==================== TICKET SERVICE ====================
export const ticketService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/tickets', { params });
    return response.data;
  },

  getById: async (id, params = {}) => {
    const response = await axiosInstance.get(`/api/helpdesk/tickets/${id}`, { params });
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/tickets/stats', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/helpdesk/tickets', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/helpdesk/tickets/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/helpdesk/tickets/${id}`);
    return response.data;
  },

  addComment: async (ticketId, data) => {
    const response = await axiosInstance.post(`/api/helpdesk/tickets/${ticketId}/comments`, data);
    return response.data;
  }
};

// ==================== SLA POLICY SERVICE ====================
export const slaPolicyService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/sla-policies', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/api/helpdesk/sla-policies/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/helpdesk/sla-policies', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/helpdesk/sla-policies/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/helpdesk/sla-policies/${id}`);
    return response.data;
  }
};

// ==================== KNOWLEDGE BASE SERVICE ====================
export const articleService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/articles', { params });
    return response.data;
  },

  getPublic: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/articles/public', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/api/helpdesk/articles/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/helpdesk/articles', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/helpdesk/articles/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/helpdesk/articles/${id}`);
    return response.data;
  },

  recordFeedback: async (id, data) => {
    const response = await axiosInstance.post(`/api/helpdesk/articles/${id}/feedback`, data);
    return response.data;
  }
};

// ==================== ARTICLE CATEGORY SERVICE ====================
export const articleCategoryService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/article-categories', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/helpdesk/article-categories', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/helpdesk/article-categories/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/helpdesk/article-categories/${id}`);
    return response.data;
  }
};

// ==================== TICKET CATEGORY SERVICE ====================
export const ticketCategoryService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/helpdesk/ticket-categories', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/helpdesk/ticket-categories', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/helpdesk/ticket-categories/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/helpdesk/ticket-categories/${id}`);
    return response.data;
  }
};

export default {
  ticket: ticketService,
  slaPolicy: slaPolicyService,
  article: articleService,
  articleCategory: articleCategoryService,
  ticketCategory: ticketCategoryService
};
